import React from 'react';
import styled from 'styled-components';
import html2canvas from 'html2canvas';
import { MdOutlineSaveAlt } from 'react-icons/md';
import { isMobile } from '../common/style';

const ShareImgBtn = () => {
  const onCapture = () => {
    html2canvas(document.getElementById('saveImg'), {
      backgroundColor: '#FBF9F9',
    }).then((canvas) => {
      onSaveAs(canvas.toDataURL('image/png'), 'image-download.png');
    });
  };

  const onSaveAs = (url, filename) => {
    var link = document.createElement('a');
    document.body.appendChild(link);
    link.href = url;
    link.download = filename;
    link.click();
    document.body.removeChild(link);
  };

  return (
    <ShareBtn onClick={onCapture}>
      <MdOutlineSaveAlt className="icons" color="#566D62" />
    </ShareBtn>
  );
};
export default ShareImgBtn;

const ShareBtn = styled.button`
  width: 86px;
  height: 86px;
  padding: 16px;
  border-radius: 100px;
  background: #dcf0e9;
  border: 3px solid #3d6c5b;
  box-shadow: 2px 3px 4px rgba(0, 0, 0, 0.25);

  &:hover {
    cursor: pointer;
    background: #86baa7;
  }

  ${isMobile} {
    width: 50px;
    height: 50px;
    padding: 8px;
    border: 2px solid #3d6c5b;
  }

  .icons {
    font-size: 48px;

    ${isMobile} {
      font-size: 27px;
    }
  }
`;
